import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/de";
import "@formatjs/intl-relativetimeformat/locale-data/fr";
import "@formatjs/intl-relativetimeformat/locale-data/it";

import { isNotEmpty } from "../utils";

const TRANSLATIONS = {
  de: {},
  en: {},
  zh: {},
  fr: {},
  it: {},
};

export function translationKeyExists(
  key: $TSFixMe,
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  language = global.configuration.language,
) {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return isNotEmpty(TRANSLATIONS[language][key]);
}

// Warning! unsafe function
export const addTranslations = (
  language: string,
  translations: object,
  overwrite = false,
) => {
  Object.keys(translations).forEach((key) => {
    if (overwrite || !translationKeyExists(key, language)) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      TRANSLATIONS[language][key] = translations[key];
    }
  });
};

async function mergeMessages(userLanguage: $TSFixMe) {
  // prettier-ignore
  const messages = (
    await import(
      /* webpackChunkName: "translations" */
      `./${userLanguage}`
      )
  ).default;
  addTranslations(userLanguage, messages);
  return messages;
}

// getTranslations :: (en|de|zh|fr|it) -> Exception<Promise<Translation>> | Translation
export function getTranslations(userLanguage: $TSFixMe) {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (TRANSLATIONS[userLanguage]["general.loading"]) {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return TRANSLATIONS[userLanguage];
  }
  throw mergeMessages(userLanguage);
}

export default TRANSLATIONS;
